import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getEnvironmentTranslationId } from '../../utils/environment';

const EnvironmentName = () => {
  const envTranslationId = getEnvironmentTranslationId();
  return <FormattedMessage id={envTranslationId} />;
};

export default EnvironmentName;
